<template>
<div class="sezione"  style="padding:0 20px;" v-if="ready">


   <div class="yo-fixed-top" style="top:212px;z-index:999;">
   <div class="row el-container" style="background:#fff;padding:16px 20px;">
      <div class="col s8">




         <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-tooltip :open-delay="1200" :content="tbName" placement="bottom" effect="dark"><el-breadcrumb-item>{{labelScheda}}</el-breadcrumb-item></el-tooltip>

         
         <!-- <el-breadcrumb-item>Anno {{isByear}}</el-breadcrumb-item> -->
         
         <!--
         <el-breadcrumb-item>Peso {{isBwgt[0]}}gr » {{isBwgt[1]}}gr</el-breadcrumb-item>
         <el-breadcrumb-item>EG (sett) {{isGaweeks[0]}} » {{isGaweeks[1]}}</el-breadcrumb-item>
         
         <el-breadcrumb-item v-if="isSex>-1">{{labelSex}}</el-breadcrumb-item>
         
         <el-breadcrumb-item v-if="isLocate>-1">{{labelLocate}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="isIugr>-1">{{labelIugr}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="isMult>-1">{{labelMult}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="isSga!='-1'">{{labelSga}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="isFdisp!='-1'">{{labelFdisp}}</el-breadcrumb-item>
         -->
         </el-breadcrumb>
      </div>
      <div class="col s4 yo-align-right">
         <div class="row">
            <div class="col s12" style="">
<!--
               <el-popover placement="top" title="Seleziona i filtri" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer red" style="float:right;padding:0 12px 0 18px;" v-on:click="changeTab('filter')">filter_alt</i>
               </el-popover>  

               <el-popover placement="top" title="Trasferimento" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;"  v-on:click="changeTab('trasferimento')">directions_bus</i>
               </el-popover>  
               
               <el-popover placement="top" title="Dimissione" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;"  v-on:click="changeTab('dimissione')">child_friendly</i>
               </el-popover>  
               
               <el-popover placement="top" title="Decorso Clinico" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;"  v-on:click="changeTab('decorso-clinico')">hotel</i>
               </el-popover>  
               
               <el-popover placement="top" title="Sala Parto" trigger="hover">
               <img slot="reference" src="../assets/ico-salaparto.png" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;height:24px;"   v-on:click="changeTab('sala-parto')"/>
               </el-popover>  

               <el-popover placement="top" title="Dati Perinatali" trigger="hover">
               <img slot="reference" src="../assets/ico-perinatale.png" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;height:24px;"  v-on:click="changeTab('dati-perinatali')" />
               </el-popover>  

               <el-popover placement="top" title="Dati Generali" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;"  v-on:click="changeTab('dati-generali')">folder_open</i>
               </el-popover>  
-->
            </div>

          </div>


      </div>
   </div>
   </div>

<div style="margin:72px 0 52px 0;">


<div v-if="tabShow=='caterpillarplot'" >
<div class="yo-text-xl  yo-color-primary yo-align-center" style="margin-bottom:12px;">Tasso di mortalità grezzo alla dimissione nella classe di EG {{gaweakDown}}-{{gaweakUp}} per centro. INNSIN 2019*</div>



<div :style="'height:'+(gHeight+gHeightMore*2)+'px'" style="background:#ddd;width:100%;position: relative;" >
<!--
   <div style="border:1px solid #fff;position:absolute;width:30px;top:40px;left:10px;" />

   <div style="border:1px solid #fff;position:absolute;width:30px;bottom:490px;left:10px;" />
   <div style="border:1px solid #fff;position:absolute;width:30px;bottom:400px;left:10px;" />
   <div style="border:1px solid #fff;position:absolute;width:30px;bottom:310px;left:10px;" />
   <div style="border:1px solid #fff;position:absolute;width:30px;bottom:220px;left:10px;" />
   <div style="border:1px solid #fff;position:absolute;width:30px;bottom:130px;left:10px;" />
   <div style="border:1px solid #fff;position:absolute;width:30px;bottom:40px;left:10px;" />
   
      <div v-if="(ordinata(63)>0 && ordinata(63)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(63))+'px'" style="border-bottom:1px solid red;position:absolute;width:100%;left:10px;" />
   -->


   <div v-if="(ordinata(100)>0 && ordinata(100)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(100))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(95)>0 && ordinata(95)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(95))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(90)>0 && ordinata(90)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(90))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(85)>0 && ordinata(85)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(85))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(80)>0 && ordinata(80)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(80))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(75)>0 && ordinata(75)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(75))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(70)>0 && ordinata(70)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(70))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(65)>0 && ordinata(65)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(65))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(60)>0 && ordinata(60)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(60))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(55)>0 && ordinata(55)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(55))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(50)>0 && ordinata(50)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(50))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(45)>0 && ordinata(45)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(45))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(40)>0 && ordinata(40)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(40))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(35)>0 && ordinata(35)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(35))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(30)>0 && ordinata(30)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(30))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(25)>0 && ordinata(25)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(25))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(20)>0 && ordinata(20)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(20))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(15)>0 && ordinata(15)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(15))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(10)>0 && ordinata(10)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(10))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
   <div v-if="(ordinata(5)>0 && ordinata(5)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(5))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
   <div v-if="(ordinata(0)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(0))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />



   <div v-if="(ordinata(100)>0 && ordinata(100)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(100)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">100</div>
   <div v-if="(ordinata(90)>0 && ordinata(90)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(90)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">90</div>
   <div v-if="(ordinata(80)>0 && ordinata(80)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(80)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">80</div>
   <div v-if="(ordinata(70)>0 && ordinata(70)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(70)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">70</div>
   <div v-if="(ordinata(60)>0 && ordinata(60)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(60)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">60</div>
   <div v-if="(ordinata(50)>0 && ordinata(50)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(50)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">50</div>
   <div v-if="(ordinata(40)>0 && ordinata(40)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(40)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">40</div>
   <div v-if="(ordinata(30)>0 && ordinata(30)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(30)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">30</div>
   <div v-if="(ordinata(20)>0 && ordinata(20)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(20)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">20</div>
   <div v-if="(ordinata(10)>0 && ordinata(10)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(10)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">10</div>
   <div v-if="(ordinata(0)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(0)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">0</div>




   <div :style="'top:'+(gHeight+gHeightMore-ordinata(q3))+'px'" style="border-bottom:1px dashed #008000;position:absolute;right:0;left:40px;" />
   <div :style="'top:'+(gHeight+gHeightMore-ordinata(network.m))+'px'" style="border-bottom:1px dashed #1a476f;position:absolute;right:0;left:40px;" />
   <div :style="'top:'+(gHeight+gHeightMore-ordinata(q1))+'px'" style="border-bottom:1px dashed #008000;position:absolute;right:0;left:40px;" />


   <div :style="'height:'+(gHeight+gHeightMore*2)+'px'" style="background:grey;float:left;width:40px;color:white;text-align:center;">


   </div>
<div  style="float:left;width:calc(100% - 40px);padding:40px 0 40px 0;"  >
   

   
      <div v-for="(itm, index) in items" :key="'_'+itm.centro" v-on:click="centroSel=itm.centro" :class="(itm.centro==centroSel?'selezionato':'')" class="g-confidenza yo-align-center" style="float:left;position:relative;" :style="'height:'+gHeight+'px;width: '+(100/items.length)+'%'" :id="'centro_'+index">


         <div class="g-confidenza-f2"  :style="'top:'+(gHeight-ordinata(itm.f2))+'px'" />
         <div class="g-confidenza-m" :style="'top:'+(gHeight-ordinata(itm.m)-5)+'px'"  />
         <div class="g-confidenza-f1" :style="'top:'+(gHeight-ordinata(itm.f1))+'px'" />

         <div class="g-confidenza-line" :style="'top:'+(gHeight-ordinata(itm.f2))+'px;bottom:'+(ordinata(itm.f1))+'px;'" style="position:absolute;width:1px;left:50%;background:black;" />


      </div>


</div>
</div>



<div :style="'height:'+40+'px'" style="background:grey;margin-bottom:22px;color:white;margin-left:40px;" >
   <div v-for="(itm, index) in items" :key="'_'+itm.centro" class="col sm yo-valign-text-center yo-align-center yo-text-s" style="height:40px;float:left;" :style="'width: '+(100/items.length)+'%'" :id="'centro_'+index">
      {{index+1}}
   </div>
</div>


<div class="row pad" style="clear:both;margin-bottom:12px;" >
      <div class="col s3 yo-text-bold yo-align-right">ASCISSE</div>
      <div class="col s9">Posizione (rango) del centro</div>
</div>
<div class="row pad" style="clear:both;margin-bottom:12px;" >
      <div class="col s3 yo-text-bold yo-align-right">ORDINATE</div>
      <div class="col s9">Tasso di mortalità (%)</div>
</div>
<div class="row pad" style="clear:both;margin-bottom:12px;" >
      <div class="col s3 yo-text-bold yo-align-right">LINEE TRATTEGGIATE</div>
      <div class="col s9">Rappresentano il tasso di mortalità mediano dell'intero network con i rispettivi Intervalli di Confidenza al 95% inferiore e superiore</div>
</div>
<div class="row pad" style="clear:both;margin-bottom:12px;" >
      <div class="col s3 yo-text-bold yo-align-right">NOTE*</div>
      <div class="col s9">Non sono stati considerati 11 centri con un numero di nati minore o uguale a 10 nella classe di EG {{gaweakDown}}-{{gaweakUp}}.<br />Sono stati esclusi i neonati con malformazione congenita letale.</div> 
</div>


<div class="row pad" style="clear:both;margin-bottom:12px;" ><div class="col s9 offset-s3">

   <div class="row " style="clear:both;background:grey;color:white" >
      <div class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">NUM</div>
      <!-- <div class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">CENTRO</div> -->
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">CASI</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">TOT</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Q1</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Mortalità (%)</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Q3</div>
   </div>



   <div class="row " style="border-bottom:1px solid lightgrey;"  >
      <div class="col s1 yo-valign-text-center yo-align-center" style="height:24px;">#</div>
      <!-- <div class="col s1 yo-valign-text-center yo-align-center" style="height:24px;" >network</div> -->
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;">{{network.valore}}</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{network.totale}}</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{q1}}</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{network.m}}</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{q3}}</div>
   </div>



   <div class="row " style="clear:both;background:grey;color:white" >
      <div class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">NUM</div>
      <div v-if="false" class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">CENTRO</div> 
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">CASI</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">TOT</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">I.C. 95% inf</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Mortalità (%)</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">I.C. 95% sup.</div>
   </div>


   <div class="row " style="border-bottom:1px solid lightgrey;" v-for="(itm, index) in items" :key="itm.centro" v-on:click="centroSel=itm.centro" >
      <div class="col s1 yo-valign-text-center yo-align-center" style="height:24px;">{{index+1}}</div>
      <div v-if="false" class="col s1 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.centro}}</div> 
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;">{{itm.valore}}</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.totale}}</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.f1}}</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.m}}</div>
      <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.f2}}</div>
   </div>

</div></div>

</div>


<div v-if="tabShow=='filter'" >
<div class="yo-text-l  yo-color-primary">FILTRI ATTIVI</div>

<div class="row pad" style="margin-top:12px;">
<div class="col s3  yo-valign-text-center yo-align-right" style="height:40px;">Peso alla nascita</div>
<div class="col s9">
   <el-slider v-model="isBwgt" range  :marks="bwgtMarks" :min="200" :max="5000" :step="10" v-on:change="filterChange"></el-slider>
</div>
</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center  yo-align-right" style="height:40px;">Età gestazionale in settimane</div>
<div class="col s9">
   <el-slider v-model="isGaweeks" range  :marks="gaweeksMarks" :min="21" :max="42" v-on:change="filterChange"></el-slider>
</div>
</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Sesso</div>
<div class="col s3">
   <el-select v-model="isSex" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="Femmina" :value="0"></el-option>
    <el-option label="Maschio" :value="1"></el-option>
    <el-option label="Indeterminato" :value="9"></el-option>
  </el-select>
</div>

<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Outborn / Inborn</div>
<div class="col s3">
   <el-select v-model="isLocate" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="InBorn" :value="0"></el-option>
    <el-option label="OutBorn" :value="1"></el-option>
  </el-select>
</div>
</div>

<div class="row pad" style="margin-top:24px;">
<!-- eliminata dopo riunione del 18 Dicembre 2020 
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Diagnosi di IUGR</div>
<div class="col s3">
   <el-select v-model="isIugr" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="No" :value="0"></el-option>
    <el-option label="Si" :value="1"></el-option>
  </el-select>
</div>
-->

<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Gestazione multipla</div>
<div class="col s3">
   <el-select v-model="isMult" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="No" :value="0"></el-option>
    <el-option label="Si" :value="1"></el-option>
  </el-select>
</div>

<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">SGA</div>
<div class="col s3">
   <el-select v-model="isSga" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="< 3° percentile" value="< 3° percentile"></el-option>
    <el-option label="< 10° percentile" value="< 3° percentile,tra 3° e 10° percentile"></el-option>
    <el-option label="> 10° percentile" value="> 10° percentile,> 97° percentile"></el-option>
    <!-- <el-option label="tra 3° e 10° percentile" value="tra 3° e 10° percentile"></el-option> -->
    <!-- <el-option label="> 10° percentile" value="> 10° percentile"></el-option> -->
    <!-- <el-option label="> 97° percentile" value="> 97° percentile"></el-option> -->
  </el-select>
</div>
</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Esito</div>
<div class="col s3">
   <el-select v-model="isFdisp" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="Dimessi al domicilio" :value="1"></el-option>
  </el-select>
</div>


</div>



<div class="yo-text-l yo-color-primary" style="margin-top:24px;">IL TUO CENTRO</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Anno</div>
<div class="col s3">
   <el-select v-model="isByear" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option v-for="item in anni" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</div>

</div>


<div class="yo-text-l yo-color-primary" style="margin-top:24px;">NETWORK DI CONFRONTO</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Network di confronto</div>
<div class="col s3">
   <el-select v-model="isConfronto" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Tutto il Network" :value="'network'"></el-option>
    <!--
    <el-option label="Nord" value="nord"></el-option>
    <el-option label="Centro" value="centro"></el-option>
    <el-option label="Sud" value="sud"></el-option>
    <el-option label="Il tuo centro" value="centro"></el-option>
    <el-option label="La tua regione" value="regione"></el-option>
    -->
  </el-select>
</div>


<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Anno</div>
<div class="col s3">
   <el-select v-model="isByearConfronto" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option v-for="item in anni" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</div>

</div>



<div class="yo-text-l red" style="margin-top:24px;">HELP</div>

Selezionare i filtri e il network di confronto e poi selezionare la sezione di proprio interesse cliccando sulle icone in alto a destra.
<br />
Le variabili in blu sono per i soli  neonati di EG minore o uguale a 31 settimane o con peso  minore di 1500 g

</div>




</div>
</div>
</template>

<script>
import { quantileSeq,std,mean } from 'mathjs'
export default {
components: {
   
},
data() {
   return {
      loading:{}
      ,ready: false
      ,needReload: false
      ,item:{}
      ,tabShow: 'caterpillarplot'
      ,testnow: 'mirko'
      ,tbName: ''

      ,isByear: 2019
      ,isBwgt: [200,5000]
      ,isGaweeks:[14,46]
      ,isSex: -1
      ,isLocate: -1
      ,isIugr: -1
      ,isMult: -1
      ,isSga: -1
      ,isFdisp: -1


      ,isConfronto: 'network'
      ,isByearConfronto: 2019

      ,anni: [{label:"2019", value:2019},{label:"2020", value:2020}]
      ,bwgtMarks:{200: '200gr',500: '500gr', 1000: '1kg', 2000: '2kg', 3000: '3kg', 4000: '4kg', 5000: '5kg'}
      ,gaweeksMarks:{14: '14',20: '20',28: '28', 36: '36', 46: '46'}

      ,gHeight:540
      ,gHeightMore:40
      ,items: []
      ,ordinataMin: 0
      ,ordinataMax: 100
      ,network: {}
      ,centroSel: this.$centro.referente.row.centro
      ,q1:0
      ,q3:0
      ,gaweakDown:22
      ,gaweakUp:31
   }
},
created () {
   this.tbName = '_'+this.$moment().format('YYYY-MM-DD H')+'_'+this.$centro.referente.row.centro+'_'+this.$teras.random()
   console.log(this.tbName)
   this.fdisp ()
},
async destroyed() {
    await this.$axios.query('doQuery','DROP TABLE IF EXISTS `r←tbName`, `r←tbNamec`;',{tbName: this.tbName})
},
methods: {
   filterChange(val){
      console.log("Change isBwgt "+val)
      this.needReload = true
   },
   async fdisp () {
      let whereValue = "fdisp=3"
      let whereNCNR = "fdisp>-1"
      this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      let q = await this.$axios.query('fetchAll',`SELECT centro AS centro, SUM(IF(←whereValue,1,0)) AS valore, SUM(IF(←whereValue,0,1)) AS valore2, count(*) AS totale, ROUND(SUM(IF(←whereValue,1,0))/count(*)*100,2) AS m, 0 AS f1, 0 AS f2
      FROM sin_inn.paziente WHERE (centro!=1 AND centro!=101 AND  centro!=10001 AND centro!=10012) AND byear = 2019 
      AND gaweeks>= ←gaweakDown AND gaweeks<= ←gaweakUp AND ←whereNCNR
      AND NOT FIND_IN_SET(bdcd1,'101,103,105,401,501,502,505,609')
      AND NOT FIND_IN_SET(bdcd2,'101,103,105,401,501,502,505,609')
      AND NOT FIND_IN_SET(bdcd3,'101,103,105,401,501,502,505,609')
      AND NOT FIND_IN_SET(bdcd4,'101,103,105,401,501,502,505,609')
      AND NOT FIND_IN_SET(bdcd5,'101,103,105,401,501,502,505,609')
      GROUP BY centro HAVING totale>15 ORDER BY m,valore,totale DESC, centro`,{whereValue:whereValue, whereNCNR:whereNCNR, gaweakDown:this.gaweakDown, gaweakUp:this.gaweakUp})

      /*
      ometto AND chiusoil>0  perchè Francesco dice di considerarli comunque chiuse
      */





      /*
      let fdisp = []
      let svalue = {centro:0,valore:0,totale:0,f1:0,f2:0,m:0}
      
      for (let item of q.result){
         if(svalue.centro!=item.id){
            if(svalue.centro>0)
               fdisp.push(svalue)
            svalue = {centro:0,valore:0,totale:0,f1:0,f2:0,m:0}
         }

         svalue.centro=item.id*1
         svalue.totale+=item.totale
         if(item.valore==1)
            svalue.valore=item.totale
         
         

  
      }
      console.log(fdisp)

      let esito = await this.$axios.post(this.$axios.apiUrl+'vue/confidenza',{items:fdisp})


      */
      let esito = await this.$axios.post(this.$axios.apiUrl+'vue/confidenza',{items:q.result})
      this.items = esito.data.data.items
      this.itemsError = esito.data.data.itemsError


      console.log("TOTALI: "+this.items.length)

      this.ordinataMin = this.items[0].f1//(this.items[0].f1 - 10>0) ? this.items[0].f1 - 10 : 0
      this.ordinataMax = parseFloat(this.items[this.items.length - 1].f2) //(parseFloat(this.items[this.items.length - 1].f2) + 10<100) ? parseFloat(this.items[this.items.length - 1].f2) + 10 : 100

      let ultimo = this.items[this.items.length - 1]
      console.log("MIN: "+this.ordinataMin+" - MAX: "+ this.ordinataMax)


      let allValues = []
      for (let itm of this.items){
         allValues.push(itm.m)
      }

      
      this.q1 = parseFloat(quantileSeq(allValues, 0.25)).toFixed(2)
      this.q3 = parseFloat(quantileSeq(allValues, 0.75)).toFixed(2)





      let qT = await this.$axios.query('fetchAll',`SELECT centro AS centro, SUM(IF(←whereValue,1,0)) AS valore, SUM(IF(←whereValue,0,1)) AS valore2, count(*) AS totale, ROUND(SUM(IF(←whereValue,1,0))/count(*)*100,2) AS m, 0 AS f1, 0 AS f2
      FROM sin_inn.paziente WHERE (centro!=1 AND centro!=101 AND  centro!=10001 AND centro!=10012) AND byear = 2019 
      AND gaweeks>= ←gaweakDown AND gaweeks<= ←gaweakUp AND ←whereNCNR
      AND NOT FIND_IN_SET(bdcd1,'101,103,105,401,501,502,505,609')
      AND NOT FIND_IN_SET(bdcd2,'101,103,105,401,501,502,505,609')
      AND NOT FIND_IN_SET(bdcd3,'101,103,105,401,501,502,505,609')
      AND NOT FIND_IN_SET(bdcd4,'101,103,105,401,501,502,505,609')
      AND NOT FIND_IN_SET(bdcd5,'101,103,105,401,501,502,505,609')
      ORDER BY m,valore,totale DESC, centro`,{whereValue:whereValue, whereNCNR:whereNCNR, gaweakDown:this.gaweakDown, gaweakUp:this.gaweakUp})
      let esitoT = await this.$axios.post(this.$axios.apiUrl+'vue/confidenza',{items:qT.result})
      this.network = esitoT.data.data.items[0]




      

      console.log("*******************************")
      //await this.$axios.query('fetchAll','SELECT * FROM ←rTable;',{rTable:this.rTable})
      this.loading.close()
      this.ready = true
   },


   ordinataP(val){
      let newval = val*this.gHeight/this.ordinataMax 
      console.log(newval*100/this.gHeight)
      return newval*100/this.gHeight
   },


   ordinata(val){
      
      //return val*10 //this.ordinataMax*val/100*10
      console.log(val*this.gHeight/this.ordinataMax)
      return val*this.gHeight/this.ordinataMax 
   },

   async changeTab(tab){
      if(this.needReload && tab!='filter'){
         console.log("NEED RELOAD")
         this.ready = false
         await this.rCentro ()
         this.needReload = false
      }
      this.tabShow = ''
      setTimeout(()=>{this.tabShow=tab}, 500)
      

   }
}, 
computed:{
   rTable:function(){      
      return 'r' + this.$centro.referente.row.centro
   },
   labelScheda: function(){
      let label = 'Non trovata'
      switch(this.tabShow){
         case 'caterpillarplot':
         label = 'Caterpillar plot'
         break

         case 'filter':
         label = "Filtri"
         break;
         case 'dati-generali':
         label = "Scheda Dati Generali"
         break;
         case 'dati-perinatali':
         label = "Scheda Dati Prinatali"
         break;
         case 'sala-parto':
         label = "Scheda Sala Parto"
         break;
         case 'decorso-clinico':
         label = "Scheda Decorso Clinico"
         break;
         case 'dimissione':
         label = "Scheda Dimissione"
         break;
         case 'trasferimento':
         label = "Scheda Transferimento"
         break;
      }
      return label
   },
   labelSex: function(){
      let label = 'Non trovata'
      switch(this.isSex){
         case 1:
         label = "Maschi"
         break;
         case 0:
         label = "Femmine"
         break;
         case 9:
         label = "Sesso Indeterminato"
         break;
      }
      return label
   },
   labelLocate: function(){
      let label = 'Non trovata'
      switch(this.isLocate){
         case 0:
         label = "InBorn"
         break;
         case 1:
         label = "OutBorn"
         break;
      }
      return label
   },
   labelIugr: function(){
      let label = 'Non trovata'
      switch(this.isIugr){
         case 0:
         label = "IUGR no"
         break;
         case 1:
         label = "IUGR si"
         break;
      }
      return label
   },
   labelMult: function(){
      let label = 'Non trovata'
      switch(this.isMult){
         case 0:
         label = "Gestazione multipla no"
         break;
         case 1:
         label = "Gestazione multipla si"
         break;
      }
      return label
   },
   labelSga: function(){
      let label = 'Non trovata'
      switch(this.isSga){
         case '< 3° percentile':
         label = "SGA < 3°"
         break;
         case 'tra 3° e 10° percentile':
         label = "SGA tra 3° e 10°"
         break;
         case '< 3° percentile,tra 3° e 10° percentile':
         label = "SGA < 10°"
         break;
         case '> 10° percentile,> 97° percentile':
         label = "SGA > 10°"
         break;
         case '> 10° percentile':
         label = "SGA > 10°"
         break;
         case '> 97° percentile':
         label = "SGA > 97°"
         break;
      }
      return label
   },
   labelFdisp: function(){
      let label = 'Non trovata'
      switch(this.isFdisp){
         case -1:
         label = "Tutti"
         break;
         case 1:
         label = "Dimessi al domicilio"
         break;
      }
      return label
   },
   labelConfronto: function(){
      let label = 'Non trovata'
      switch(this.isConfronto){
         case 'network':
         label = "TUTTO IL NETWORK"
         break;
         case 1:
         label = "Gestazione multipla si"
         break;
      }
      return label
   }
}
}
</script>


<style >
.report_basico .vRow{
    background: #BDD1E8;
    background: #fbeafa;

}

.report_basico .vRow:nth-child(odd) {
    color: grey;
    background: #d7e5f7;
}
</style>
